import { useCallback, useEffect, useState } from 'react';

interface IUseInfiniteScroll {
  callback: () => void;
  isLoading: boolean;
  onScrollBottomActive?: boolean;
  infiniteScroll?: boolean;
  disabled?: boolean;
}

export const useInfiniteScroll = ({
  callback,
  isLoading,
  infiniteScroll,
  disabled,
}: IUseInfiniteScroll) => {
  const [bottomReached, setBottomReached] = useState(false);

  const handleScroll = useCallback(
    (event: any) => {
      const height = event.target.clientHeight;
      const scrollTop = event.target.scrollTop;
      const contentHeight = event.target.scrollHeight;
      const scrollBottom = contentHeight - (scrollTop + height);

      if (scrollBottom <= 1 && !bottomReached && !disabled) {
        callback();
        setBottomReached(true);
      } else if (scrollBottom > 1 && bottomReached) {
        setBottomReached(false);
      }
    },
    [callback, bottomReached],
  );

  useEffect(() => {
    const scrollContainer = window.document.getElementById('private_layout_details');

    if (infiniteScroll && scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    }
  }, [isLoading, infiniteScroll, handleScroll]);
};
